export const NATIVE_HOST_INLINE_CHECK = "!!window.ReactNativeWebView"

export const inPlainAppWebView = (): boolean => {
  if (typeof window === "undefined") return false
  const host = window as unknown as { ReactNativeWebView?: unknown; NeloBridgeHost?: unknown }
  return host.ReactNativeWebView !== undefined && host.NeloBridgeHost === undefined
}
